// TODO: This shouldn't be hardcoded, but for now since EUR is the only currency that supports margin, it'll be fine
export const CURRENCY_ELIGIBLE_FOR_MARGIN = 'EUR';
